import { get } from 'lodash-es';
// eslint-disable-next-line venom/no-venom-api-calls
import { VenomApi } from 'client/data/api/api-client';
import { getCaramelAPIPayload } from 'site-modules/microsite/dealers/utils/delaer-center-enroll-form-utils';
import { ENROLL_MODE } from 'site-modules/microsite/dealers/constants/digital-checkout';

export const enrollDealer = async data => {
  const { dealer, fields, mode, location } = data;
  const isEnrollMode = mode === ENROLL_MODE;
  const options = {
    method: 'POST',
    retries: 0,
    headers: {
      'content-type': 'application/json',
    },
    showAPIError: true,
    body: JSON.stringify(getCaramelAPIPayload({ dealer, location, fields, mode })),
  };

  // eslint-disable-next-line venom/no-venom-api-calls
  return VenomApi.fetchJson(`/car-buying/caramel/${isEnrollMode ? '' : `${get(dealer, 'franchiseId')}`}`, options)
    .then(res => res)
    .catch(error => ({
      isError: true,
      error,
    }));
};
